// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nw-0";
export var assigneeDetails = "_nw-1";
export var assigneeInfo = "_nw-2";
export var dropdownContainer = "_nw-4";
export var dropdownImage = "_nw-5";
export var editAssigneeInfo = "_nw-3";
export var editAssigneeModalContainer = "_nw-6";
export var hidden = "_nw-8";
export var input = "_nw-7";